export default "/images/activity.svg?24e13b02f43c5d60dddc9dc4d4fcbcfc";